import { Typography, TypographyProps } from '@mui/material'

const Text = ({ children, sx, ...rest }: TypographyProps) => {
  return (
    <Typography
      sx={{
        fontFamily: 'Nunito',
        fontWeight: 400,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  )
}

export default Text
